import axios from 'axios';
import { API_URL } from '../settings';

const token = localStorage.getItem('@ConsulteAqui:token');

const AxiosInstance = axios.create({
  baseURL: API_URL, 
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json; charset=utf-8',
  },
});


export default AxiosInstance;